import { render, staticRenderFns } from "./CompetitionMatches.vue?vue&type=template&id=31c2be3c&scoped=true"
import script from "./CompetitionMatches.vue?vue&type=script&lang=js"
export * from "./CompetitionMatches.vue?vue&type=script&lang=js"
import style0 from "./CompetitionMatches.vue?vue&type=style&index=0&id=31c2be3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2be3c",
  null
  
)

export default component.exports